import React, { Component } from "react";
import {
    message,
    Modal,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
    Upload,
    Collapse,
    Alert,
    Form as FormInitial,
    Checkbox,
    Tabs,
    Tooltip,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { encodeId, decodeId } from "../../../../Components/idEncoder";
import {
  MensajeError,
    dineroDisabledMask,
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    ModalItem,
    ButtonItem,
    NotificacionPolizas,
    NotificacionMovimientosInventario,
    round6Decimals,
    HeaderItem,
    BoxItem,
    DatePickerItem,
    SwitchItem,
    ErrorItem,
    TextAreaItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreoDevolucion from "../MandarCorreoDevolucion/MandarCorreoDevolucion";
import devolucionFPdf from "../../../../Pdf/devolucionFPdf";
import devolucionRPdf from "../../../../Pdf/devolucionRPdf";
import TabRelaciones from "../../Ventas/AgregarVenta/TabRelaciones/TabRelaciones";
import AgregarLotes from "../../LotesCaducidades/AgregarLotes/AgregarLotes";
import ElegirLotesDevolucion from "../ElegirLotesDevolucion/ElegirLotesDevolucion";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

moment.locale("es");

class AgregarDevolucion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        objetoProveedores: null,
        todasProveedores: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoBancos: null,
        todasBancos: null,
        objetoInsumos: (
            <Option disabled value={0} key={0}>
                Seleccione un proveedor primero
            </Option>
        ),
        todasInsumos: [],
        objetoMonedas: null,
        todasMonedas: null,
        impuestos: [],
        modalConfirmacion: false,
        valuesForm: null,
        ventaId: this.props.location.state.ventaId,
        datosVenta: null,
        tipoDeCambioVenta: 0,
        totalVenta: 0,
        totalPagarVenta: 0,
        subtotalVenta: 0,
        arrayImpuestosVenta: [],
        arrayRetencionesVenta: [],
        modalCorreo: false,
        modalCorreoId: null,
        modalAgregarLotes: false,
        modalAgregarLotesIndex: null,
        modalAgregarLotesLotes: null,
        modalAgregarLotesInsumoId: null,
        modalElegirLotesDevolucion: false,
        modalElegirLotesDevolucionIndex: null,
        modalElegirLotesDevolucionLotes: null,
        modalElegirLotesDevolucionInsumoId: null,
        modalElegirLotesDevolucionCantidad: null,
        loadingLotesExcel: false,
        instruccionesLotesVisibles: false,
    };
    async componentDidMount() {
        this.setState({ loading: true });
        await this.consultarTodo()
        if (this.props?.location?.state?.fileName) {
            this.leerXmlData(this.props.location.state)
        }
        this.setState({ loading: false });
    }

    promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));

    async consultarTodo() {

        this.setState({ loading: true });
        await axios
            .post(
                "devoluciones/selectDatosParaDevolucion",
                { empresaId: this.props.empresaId, ventaId: this.state.ventaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    let total = 0;
                    let subtotal = 0;
                    let arrayImpuestos = [];
                    let arrayRetenciones = [];
                    let cuentasCliente = 0;
                    this.formRef.current.setFieldsValue({
                        ...res.data.venta,
                        relacionesCFDI: res.data?.venta?.dataFactura?.uuid ? [
                            {
                                tipoRelacion: "03",
                                uuid: res.data?.venta?.dataFactura?.uuid || "",
                            }
                        ] : [],
                        usoDeCfdiId: "6123bd944518d23048736746",
                        formaDePagoId: "6125149afe07662acc100d62",
                        tipoDeCambioVenta: res.data.venta.tipoDeCambio,
                        factura: res.data.venta.factura ? 1 : 2,
                        insumos: res.data.venta.insumos.map((valueInsumo) => {
                            let clienteId = res.data.venta.clienteId;
                            let tipoDeCambio = 1
                            const insumo = res.data.insumosVenta.find(
                                (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
                            );
                            const precioUnitario = valueInsumo.precioUnitario - (valueInsumo.precioRebajado || 0);
                            const cantidad = valueInsumo.cantidad - (valueInsumo.devuelto || 0);
                            const descuento = valueInsumo.descuento || 0;

                            if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
                                //1
                                const subtotal = round6Decimals(cantidad * precioUnitario);
                                //2
                                const totalDescuento = round6Decimals(subtotal * (descuento / 100));
                                //3
                                const totalEntrada = round6Decimals(subtotal - totalDescuento);
                                valueInsumo.subtotal = totalEntrada;

                                let totalImpuestos = 0;
                                let arrayImpuestos = insumo.impuestos.map(
                                    //4
                                    (valueImpuesto) => {
                                        let totalImpuesto;
                                        let baseImpuesto;
                                        let montoImpuesto;
                                        if (valueImpuesto.tasaCuota === 1) {
                                            totalImpuesto = round6Decimals(
                                                totalEntrada * (valueImpuesto.monto / 100)
                                            );
                                            baseImpuesto = totalEntrada
                                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                                        } else if (valueImpuesto.tasaCuota === 2) {
                                            totalImpuesto = round6Decimals(
                                                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                                            );
                                            baseImpuesto = (totalEntrada + totalImpuestos)
                                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                                        } else if (valueImpuesto.tasaCuota === 3) {
                                            totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                                            baseImpuesto = cantidad
                                            montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                                        } else if (valueImpuesto.tasaCuota === 5) {
                                            totalImpuesto = 0
                                            baseImpuesto = totalEntrada
                                            montoImpuesto = 0
                                        }
                                        totalImpuestos += totalImpuesto;
                                        return {
                                            tasaCuota: valueImpuesto.tasaCuota,
                                            impuesto: valueImpuesto.impuesto,
                                            montoImpuesto: montoImpuesto,
                                            local: valueImpuesto.local,
                                            baseImpuesto: baseImpuesto,
                                            descripcionFactura: valueImpuesto.descripcionFactura,
                                            totalImpuestos: totalImpuesto,
                                        };
                                    }
                                );
                                valueInsumo.impuestos = totalImpuestos;
                                valueInsumo.arrayImpuestos = arrayImpuestos;
                                //5
                                valueInsumo.total = round2Decimals(
                                    valueInsumo.subtotal + totalImpuestos
                                );

                                if (clienteId) {
                                    //Consultar cliente

                                    const cliente = res.data.clientes.find(
                                        (valueP) => valueP._id === clienteId
                                    );
                                    //6
                                    let totalRetenciones = 0;
                                    let arrayRetenciones = []
                                    cliente.retenciones.map((valueRetencion) => {
                                        //7
                                        let totalRetencion;
                                        let baseRetencion;
                                        if (valueRetencion.tasaCuota === 1) {
                                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                                            baseRetencion = totalEntrada
                                        } else if (valueRetencion.tasaCuota === 2) {
                                            totalRetencion =
                                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                                            baseRetencion = (totalEntrada + totalImpuestos)
                                        }
                                        totalRetenciones += totalRetencion;
                                        arrayRetenciones.push({
                                            tasaCuota: valueRetencion.tasaCuota,
                                            impuesto: valueRetencion.impuesto,
                                            montoRetencion: valueRetencion.monto,
                                            local: valueRetencion.local,
                                            baseRetencion: baseRetencion,
                                            descripcionFactura: valueRetencion.descripcionFactura,
                                            totalRetenciones: totalRetencion,
                                        });
                                        return null
                                    })
                                    insumo.retenciones.map((valueRetencion) => {
                                        if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                                            //7
                                            let totalRetencion;
                                            let baseRetencion;
                                            if (valueRetencion.tasaCuota === 1) {
                                                totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                                                baseRetencion = totalEntrada
                                            } else if (valueRetencion.tasaCuota === 2) {
                                                totalRetencion =
                                                    round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                                                baseRetencion = (totalEntrada + totalImpuestos)
                                            }
                                            totalRetenciones += totalRetencion;
                                            arrayRetenciones.push({
                                                tasaCuota: valueRetencion.tasaCuota,
                                                impuesto: valueRetencion.impuesto,
                                                montoRetencion: valueRetencion.monto,
                                                local: valueRetencion.local,
                                                baseRetencion: baseRetencion,
                                                descripcionFactura: valueRetencion.descripcionFactura,
                                                totalRetenciones: totalRetencion,
                                            });
                                        }
                                        return null
                                    })
                                    valueInsumo.retenciones = totalRetenciones;
                                    valueInsumo.arrayRetenciones = arrayRetenciones;
                                }

                            }

                            subtotal += valueInsumo.subtotal;
                            total += valueInsumo.total;

                            if (valueInsumo.arrayImpuestos) {

                                valueInsumo?.arrayImpuestos?.map((valueImpuestos) => {
                                    let index = arrayImpuestos.findIndex(
                                        (valueImpuestosAnterios) =>
                                            valueImpuestosAnterios.descripcionFactura ===
                                            valueImpuestos.descripcionFactura
                                            &&
                                            valueImpuestosAnterios.tasaCuota ===
                                            valueImpuestos.tasaCuota
                                            &&
                                            valueImpuestosAnterios.impuesto ===
                                            valueImpuestos.impuesto
                                    );
                                    if (index !== -1) {
                                        let newItem = {
                                            totalImpuestos:
                                                arrayImpuestos[index].totalImpuestos +
                                                valueImpuestos.totalImpuestos,
                                            baseImpuesto:
                                                arrayImpuestos[index].baseImpuesto +
                                                valueImpuestos.baseImpuesto,
                                            descripcionFactura:
                                                valueImpuestos.descripcionFactura,
                                            tasaCuota:
                                                valueImpuestos.tasaCuota,
                                            impuesto:
                                                valueImpuestos.impuesto,
                                            montoImpuesto:
                                                valueImpuestos.montoImpuesto,
                                            local: valueImpuestos.local,
                                        };
                                        arrayImpuestos.splice(index, 1, newItem);
                                    } else {
                                        arrayImpuestos.push({
                                            tasaCuota: valueImpuestos.tasaCuota,
                                            local: valueImpuestos.local,
                                            impuesto: valueImpuestos.impuesto,
                                            montoImpuesto: valueImpuestos.montoImpuesto,
                                            baseImpuesto: valueImpuestos.baseImpuesto,
                                            descripcionFactura: valueImpuestos.descripcionFactura,
                                            totalImpuestos: valueImpuestos.totalImpuestos,
                                        });
                                    }
                                    return null;
                                });
                            }
                            if (valueInsumo.arrayRetenciones) {
                                valueInsumo.arrayRetenciones.map((valueRetenciones) => {
                                    let index = arrayRetenciones.findIndex(
                                        (valueRetencionesAnterios) =>
                                            valueRetencionesAnterios.descripcionFactura ===
                                            valueRetenciones.descripcionFactura
                                            &&
                                            valueRetencionesAnterios.tasaCuota ===
                                            valueRetenciones.tasaCuota
                                            &&
                                            valueRetencionesAnterios.impuesto ===
                                            valueRetenciones.impuesto
                                    );
                                    cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                                    if (index !== -1) {
                                        let newItem = {
                                            totalRetenciones:
                                                arrayRetenciones[index].totalRetenciones +
                                                valueRetenciones.totalRetenciones,
                                            baseRetencion:
                                                arrayRetenciones[index].baseRetencion +
                                                valueRetenciones.baseRetencion,
                                            descripcionFactura:
                                                valueRetenciones.descripcionFactura,
                                            tasaCuota:
                                                valueRetenciones.tasaCuota,
                                            impuesto:
                                                valueRetenciones.impuesto,
                                            montoRetencion:
                                                valueRetenciones.montoRetencion,
                                            local: valueRetenciones.local,
                                        };
                                        arrayRetenciones.splice(index, 1, newItem);
                                    } else {
                                        arrayRetenciones.push({
                                            tasaCuota: valueRetenciones.tasaCuota,
                                            impuesto: valueRetenciones.impuesto,
                                            montoRetencion: valueRetenciones.montoRetencion,
                                            baseRetencion: valueRetenciones.baseRetencion,
                                            local: valueRetenciones.local,
                                            descripcionFactura: valueRetenciones.descripcionFactura,
                                            totalRetenciones: valueRetenciones.totalRetenciones,
                                        });
                                    }
                                    return null;
                                });
                            }

                            return {
                                ...valueInsumo,
                                precioUnitario: valueInsumo.precioUnitario - (valueInsumo.precioRebajado || 0),
                                cantidad: valueInsumo.cantidad - (valueInsumo.devuelto || 0),
                                insumoCompleto: insumo,
                            }
                        })
                    });
                    this.setState({
                        factura: res.data.venta.factura ? 1 : 2,
                        datosVenta: res.data.venta,
                        tipoDeCambioVenta: res.data.venta.tipoDeCambio,
                        totalVenta: total,
                        totalPagarVenta: round2Decimals(total - cuentasCliente),
                        subtotalVenta: subtotal,
                        arrayImpuestosVenta: arrayImpuestos,
                        arrayRetencionesVenta: arrayRetenciones,
                        todasClientes: res.data.clientes,
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasFormasDePago: res.data.formasDePago,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasBancos: res.data.bancosYCajas,
                        todasInsumos: res.data.insumosVenta,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        objetoClientes: res.data.clientes.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.stringBuscar}
                                </Option>
                            );
                        }),
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoInsumos: res.data.insumosVenta.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.stringBuscar}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoBancos: res.data.bancosYCajas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                } else {
                    message.warning('No se encontro informacion de la venta')
                }
            });

        this.setState({ loading: false });

    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        if (!values.insumos || values.insumos?.length === 0)
            return message.warning("Agregue insumos para agregar la venta");

        let insumos = values.insumos.filter(valueInsumo => valueInsumo.cantidadNC && valueInsumo.cantidadNC > 0);

        if (!insumos || insumos?.length === 0)
            return message.warning("Agregue insumos para agregar la venta");

        for (const valueInsumo of insumos) {
            const insumoCompleto = valueInsumo.insumoCompleto;
            if (insumoCompleto?.inventariable && insumoCompleto?.lotesCaducidades) {
                const sumaLotes = (valueInsumo.lotesDevolucion || []).reduce((acc, valueLote) => acc + (valueLote.cantidad || 0), 0);
                if (Math.abs(sumaLotes - valueInsumo.cantidadNC) > 0.0001) {
                    return message.info(`Elija de qué lote(s) de la venta se devuelve el insumo "${insumoCompleto.descripcion}" (la cantidad repartida entre lotes debe ser igual a la cantidad devuelta)`);
                }
            }
        }

        if (values.monedaId === this.state.datosVenta?.monedaId && values.monedaId !== '60c7e4396465ad440c41c15a') {
            if (round2Decimals(values.tipoDeCambio) !== round2Decimals(values.tipoDeCambioVenta)) {
                return message.error('La moneda de la devolución y de la venta son iguales; el tipo de cambio de ambas debe ser el mismo');
            }
        }

        this.setState({ loading: true });
        let total = 0;
        let subtotal = 0;
        let arrayImpuestos = [];
        let arrayRetenciones = [];
        let cuentasCliente = 0;
        insumos.map((value) => {
            total += value.subtotalNC;
            subtotal += value.subtotalNC;
            value.arrayImpuestosNC.map((valueImpuestos) => {
                let index = arrayImpuestos.findIndex(
                    (valueImpuestosAnterios) =>
                        valueImpuestosAnterios.descripcionFactura ===
                        valueImpuestos.descripcionFactura
                        &&
                        valueImpuestosAnterios.tasaCuota ===
                        valueImpuestos.tasaCuota
                        &&
                        valueImpuestosAnterios.impuesto ===
                        valueImpuestos.impuesto
                );
                if (index !== -1) {
                    let newItem = {
                        totalImpuestos:
                            arrayImpuestos[index].totalImpuestos +
                            valueImpuestos.totalImpuestos,
                        baseImpuesto:
                            arrayImpuestos[index].baseImpuesto +
                            valueImpuestos.baseImpuesto,
                        descripcionFactura:
                            valueImpuestos.descripcionFactura,
                        tasaCuota:
                            valueImpuestos.tasaCuota,
                        impuesto:
                            valueImpuestos.impuesto,
                        montoImpuesto:
                            valueImpuestos.montoImpuesto,
                        local: valueImpuestos.local,
                    };
                    arrayImpuestos.splice(index, 1, newItem);
                } else {
                    arrayImpuestos.push({
                        tasaCuota: valueImpuestos.tasaCuota,
                        local: valueImpuestos.local,
                        impuesto: valueImpuestos.impuesto,
                        montoImpuesto: valueImpuestos.montoImpuesto,
                        baseImpuesto: valueImpuestos.baseImpuesto,
                        descripcionFactura: valueImpuestos.descripcionFactura,
                        totalImpuestos: valueImpuestos.totalImpuestos,
                    });
                }
                return null;
            });
            if (value.arrayRetencionesNC) {
                value.arrayRetencionesNC.map((valueRetenciones) => {
                    let index = arrayRetenciones.findIndex(
                        (valueRetencionesAnterios) =>
                            valueRetencionesAnterios.descripcionFactura ===
                            valueRetenciones.descripcionFactura
                            &&
                            valueRetencionesAnterios.tasaCuota ===
                            valueRetenciones.tasaCuota
                            &&
                            valueRetencionesAnterios.impuesto ===
                            valueRetenciones.impuesto
                    );
                    cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                    if (index !== -1) {
                        let newItem = {
                            totalRetenciones:
                                arrayRetenciones[index].totalRetenciones +
                                valueRetenciones.totalRetenciones,
                            baseRetencion:
                                arrayRetenciones[index].baseRetencion +
                                valueRetenciones.baseRetencion,
                            descripcionFactura:
                                valueRetenciones.descripcionFactura,
                            tasaCuota:
                                valueRetenciones.tasaCuota,
                            impuesto:
                                valueRetenciones.impuesto,
                            montoRetencion:
                                valueRetenciones.montoRetencion,
                            local: valueRetenciones.local,
                        };
                        arrayRetenciones.splice(index, 1, newItem);
                    } else {
                        arrayRetenciones.push({
                            tasaCuota: valueRetenciones.tasaCuota,
                            impuesto: valueRetenciones.impuesto,
                            montoRetencion: valueRetenciones.montoRetencion,
                            baseRetencion: valueRetenciones.baseRetencion,
                            local: valueRetenciones.local,
                            descripcionFactura: valueRetenciones.descripcionFactura,
                            totalRetenciones: valueRetenciones.totalRetenciones,
                        });
                    }
                    return null;
                });
            }
            return null;
        });
        arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
            total += round2Decimals(valueImpuesto.totalImpuestos)
            return {
                ...valueImpuesto,
                totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
            }
        })

        let tipoDeCambioVenta = values.tipoDeCambioVenta || this.state.tipoDeCambioVenta
        let tipoDeCambioPago = values.tipoDeCambio
        const equivalencia = tipoDeCambioPago / tipoDeCambioVenta

        if (round2Decimals(subtotal * equivalencia) > round2Decimals(this.state.subtotalVenta) || round2Decimals(total * equivalencia) > round2Decimals(this.state.totalVenta) || round2Decimals((total - cuentasCliente) * equivalencia) > round2Decimals(this.state.totalPagarVenta)) {
            this.setState({ loading: false });
            return message.info('No se puede capturar un monto mayor a la venta')
        }

        axios
            .post(
                "devoluciones/agregarDevolucion",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    total,
                    subtotal,
                    cuentasCliente: round2Decimals(cuentasCliente),
                    totalPagar: round2Decimals(total - cuentasCliente),
                    arrayImpuestos,
                    arrayRetenciones,
                    entregarInsumos: this.state.entregarInsumos,
                    ubicacionesEnvio: this.state.ubicacionesEnvio,
                    mercanciasEnvio: this.state.mercanciasEnvio,
                    ventaId: this.state.ventaId
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una devolución");
                    if (res.data.respuestaFactura.status === "success") {
                        if (window.registrarMovimiento) {
                            const dataSat = res.data.respuestaFactura.dataSat;
                            const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'D') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

                            window.registrarMovimiento({
                                titulo: 'Devolución Emitida',
                                mensaje: `${nombreArchivo} - Haga click para descargar`,
                                icono: 2,
                                onClick: () => {
                                    var xmltext = res.data.respuestaFactura.data.cfdi;

                                    var filename = nombreArchivo + ".xml";
                                    var pom = document.createElement("a");
                                    var bb = new Blob([xmltext], { type: "text/plain" });

                                    pom.setAttribute("href", window.URL.createObjectURL(bb));
                                    pom.setAttribute("download", filename);

                                    pom.dataset.downloadurl = [
                                        "text/plain",
                                        pom.download,
                                        pom.href,
                                    ].join(":");
                                    pom.draggable = true;
                                    pom.classList.add("dragout");

                                    pom.click();

                                    const pdf = devolucionFPdf(res.data);

                                    pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                                },
                            });
                        }

                        NotificacionPolizas(res.data.polizasId);
                        NotificacionMovimientosInventario(res.data.movimientosIds);
                        this.setState({
                            modalCorreo: true,
                            modalCorreoId: res.data.devolucionId,
                        });
                    } else {
                        if (window.registrarMovimiento) {
                            const dataSat = res.data.respuestaFactura.dataSat;
                            const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'D') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )';

                            window.registrarMovimiento({
                                titulo: 'Devolución Emitida',
                                mensaje: `${nombreArchivo} - Haga click para descargar`,
                                icono: 2,
                                onClick: () => {
                                    const pdf = devolucionRPdf(res.data);

                                    pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                                },
                            });
                        }

                        NotificacionPolizas(res.data.polizasId);
                        NotificacionMovimientosInventario(res.data.movimientosIds);
                        this.setState({
                            modalCorreo: true,
                            modalCorreoId: res.data.devolucionId,
                        });
                    }
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar la devolución",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y la devolución no se registro");
                }
            });
    }

    atras() {
        this.props.history.goBack();
    }
    onChangeMoneda(value) {
        if (value && value !== '60c7e4396465ad440c41c15a') {
            if (value === this.state.datosVenta?.monedaId) {
                this.formRef.current.setFieldsValue({
                    tipoDeCambio: this.state.datosVenta?.tipoDeCambio,
                });
                return;
            }
            axios
                .post(
                    "tipoDeCambio/obtenerTipoDeCambio",
                    {
                        monedaId: value,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        if (res.data.monedaString && res.data.dia) {
                            message.success("Se ha obtenido el tipo de cambio" + (res.data.monedaString ? (" " + res.data.monedaString) : '') + (res.data.dia ? (' del día ' + res.data.dia) : ''));
                        }
                        this.formRef.current.setFieldsValue({
                            tipoDeCambio: res.data.tipoDeCambio,
                        });
                    }
                });
        }
    }
    async onChangePrecioCantidadDescuentoNC(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        const cantidadNC = arrayValue[key].cantidadNC;
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if (precioUnitario && cantidadNC && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidadNC * precioUnitario);
            //2
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotalNC = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestosNC = totalImpuestos;
            arrayValue[key].arrayImpuestosNC = arrayImpuestos;
            //5
            arrayValue[key].totalNC = round2Decimals(
                arrayValue[key].subtotalNC + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retencionesNC = totalRetenciones;
                arrayValue[key].arrayRetencionesNC = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    onChangeCliente(valueId) {
        const contado = this.formRef.current.getFieldValue("contado");
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === valueId
        );
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        if (cliente.vendedorId && this.state.ponerVendedor && this.state.todasUsuarios?.find(u => u._id?.toString() === cliente.vendedorId?.toString())) {
            objetoCambiar.vendedorId = cliente.vendedorId
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            }
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
    }
    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ clienteId: undefined });
        }
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    }
    cerrarMandarCorreoDevolucion() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current.resetFields();
        this.atras();
    }
    abrirAgregarLotes(index, lotes, insumoId) {
        this.setState({
            modalAgregarLotes: true,
            modalAgregarLotesIndex: index,
            modalAgregarLotesLotes: lotes || [],
            modalAgregarLotesInsumoId: insumoId,
        });
    }
    cerrarAgregarLotes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos');
        insumos[this.state.modalAgregarLotesIndex].lotes = value;
        this.formRef.current.setFieldsValue({ insumos });
        this.setState({
            modalAgregarLotes: false,
            modalAgregarLotesIndex: null,
            modalAgregarLotesLotes: null,
            modalAgregarLotesInsumoId: null,
        });
    }
    abrirElegirLotesDevolucion(index, lotes, insumoId, cantidad) {
        this.setState({
            modalElegirLotesDevolucion: true,
            modalElegirLotesDevolucionIndex: index,
            modalElegirLotesDevolucionLotes: lotes || [],
            modalElegirLotesDevolucionInsumoId: insumoId,
            modalElegirLotesDevolucionCantidad: cantidad,
        });
    }
    cerrarElegirLotesDevolucion(value) {
        const insumos = this.formRef.current.getFieldValue('insumos');
        insumos[this.state.modalElegirLotesDevolucionIndex].lotesDevolucion = value;
        this.formRef.current.setFieldsValue({ insumos });
        this.setState({
            modalElegirLotesDevolucion: false,
            modalElegirLotesDevolucionIndex: null,
            modalElegirLotesDevolucionLotes: null,
            modalElegirLotesDevolucionInsumoId: null,
            modalElegirLotesDevolucionCantidad: null,
        });
    }

    insumosPendientesDeLotes() {
        const insumos = this.formRef.current.getFieldValue('insumos') || [];
        return insumos
            .map((insumo, arrayKey) => ({ insumo, arrayKey }))
            .filter(({ insumo }) =>
                insumo?.insumoCompleto?.inventariable &&
                insumo?.insumoCompleto?.lotesCaducidades &&
                insumo?.cantidadNC > 0
            );
    }

    descargarPlantillaLotes = async () => {
        const pendientes = this.insumosPendientesDeLotes();
        if (pendientes.length === 0) {
            return message.info('No hay insumos con lotes pendientes de repartir');
        }

        this.setState({ loadingLotesExcel: true });
        let resData;
        try {
            const res = await axios.post(
                'lotes/selectLotesSalidaVentaMultiple',
                {
                    empresaId: this.props.empresaId,
                    ventaId: this.state.ventaId,
                    insumoIds: pendientes.map(({ insumo }) => insumo.insumoId),
                },
                { headers: this.props.headersToken }
            );
            resData = res.data;
        } catch (err) {
            this.setState({ loadingLotesExcel: false });
            return message.error('No se pudieron consultar los lotes de la venta');
        }
        this.setState({ loadingLotesExcel: false });

        if (resData.success !== 2) {
            return message.error(resData.message || 'No se pudieron consultar los lotes de la venta');
        }

        const filas = [];
        const sinLotes = [];
        pendientes.forEach(({ insumo }) => {
            const resultado = resData.resultados.find(r => r.insumoId?.toString() === insumo.insumoId?.toString());
            const lotes = resultado?.lotesDisponibles || [];
            if (lotes.length === 0) {
                sinLotes.push(insumo.insumoCompleto?.descripcion || insumo.insumoId);
                return;
            }
            lotes.forEach(lote => {
                filas.push({
                    'Clave': insumo.insumoCompleto?.clave || '',
                    'Insumo': insumo.insumoCompleto?.descripcion || '',
                    'Lote': lote.lote || lote.numero || '',
                    'Caducidad': lote.caducidad ? moment(lote.caducidad).format('DD/MM/YYYY') : '',
                    'Vendido': lote.cantidad,
                    'Ya devuelto': lote.cantidadDevuelta || 0,
                    'Disponible': lote.saldo,
                    'Cantidad a devolver': '',
                    '_insumoId': encodeId(insumo.insumoId.toString()),
                    '_salidaId': encodeId(lote.salidaId.toString()),
                });
            });
        });

        if (filas.length === 0) {
            return message.warning('Ninguno de los insumos pendientes tiene lotes de origen para esta venta');
        }

        const hoja = XLSX.utils.json_to_sheet(filas);
        hoja['!cols'] = [
            { wch: 14 }, { wch: 40 }, { wch: 14 }, { wch: 12 },
            { wch: 10 }, { wch: 12 }, { wch: 12 }, { wch: 18 },
            { wch: 12 }, { wch: 12 },
        ];
        const libro = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(libro, hoja, 'Lotes');
        XLSX.writeFile(libro, 'plantillaLotesDevolucion.xlsx');

        if (sinLotes.length > 0) {
            message.warning(`No se encontraron lotes de origen para: ${sinLotes.join(', ')}. Repártelos manualmente con el botón "Lote origen".`);
        }
    }

    cargarExcelLotes = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const libro = XLSX.read(e.target.result, { type: 'array' });
                const hoja = libro.Sheets[libro.SheetNames[0]];
                const filas = XLSX.utils.sheet_to_json(hoja);
                this.procesarExcelLotes(filas);
            } catch (err) {
                console.log(err);
                message.error('No se pudo leer el archivo Excel');
            }
        };
        reader.readAsArrayBuffer(file);
    }

    procesarExcelLotes = async (filas) => {
        const pendientes = this.insumosPendientesDeLotes();
        if (pendientes.length === 0) {
            return message.info('No hay insumos con lotes pendientes de repartir');
        }
        const pendientesPorInsumoId = new Map(pendientes.map((p) => [p.insumo.insumoId.toString(), p]));

        const errores = [];
        // insumoId -> [{ salidaId, cantidad }]
        const repartoPorInsumoId = new Map();

        filas.forEach((fila, i) => {
            const numeroFila = i + 2; // 1 = encabezado
            const cantidad = fila['Cantidad a devolver'];
            if (cantidad === '' || cantidad === undefined || cantidad === null) return;

            const cantidadNum = Number(cantidad);
            if (!Number.isFinite(cantidadNum) || cantidadNum < 0) {
                errores.push(`Fila ${numeroFila}: "Cantidad a devolver" no es un número válido`);
                return;
            }
            if (cantidadNum === 0) return;

            const insumoId = fila['_insumoId'] ? decodeId(String(fila['_insumoId'])) : null;
            const salidaId = fila['_salidaId'] ? decodeId(String(fila['_salidaId'])) : null;
            if (!insumoId || !salidaId) {
                errores.push(`Fila ${numeroFila}: no se pudo identificar el insumo o el lote (no edites las columnas _insumoId / _salidaId)`);
                return;
            }

            const pendiente = pendientesPorInsumoId.get(insumoId);
            if (!pendiente) {
                errores.push(`Fila ${numeroFila} (${fila['Insumo'] || insumoId}): este insumo ya no tiene una cantidad devuelta capturada en el formulario`);
                return;
            }

            if (!repartoPorInsumoId.has(insumoId)) repartoPorInsumoId.set(insumoId, []);
            repartoPorInsumoId.get(insumoId).push({ salidaId, cantidad: cantidadNum, numeroFila, nombre: fila['Insumo'] });
        });

        if (repartoPorInsumoId.size === 0) {
            if (errores.length > 0) return this.mostrarErroresExcelLotes(errores);
            return message.info('El Excel no tiene cantidades para repartir');
        }

        this.setState({ loadingLotesExcel: true });
        let resData;
        try {
            const res = await axios.post(
                'lotes/selectLotesSalidaVentaMultiple',
                {
                    empresaId: this.props.empresaId,
                    ventaId: this.state.ventaId,
                    insumoIds: Array.from(repartoPorInsumoId.keys()),
                },
                { headers: this.props.headersToken }
            );
            resData = res.data;
        } catch (err) {
            this.setState({ loadingLotesExcel: false });
            return message.error('No se pudieron validar los lotes contra la venta');
        }
        this.setState({ loadingLotesExcel: false });

        if (resData.success !== 2) {
            return message.error(resData.message || 'No se pudieron validar los lotes contra la venta');
        }

        for (const [insumoId, renglones] of repartoPorInsumoId.entries()) {
            const pendiente = pendientesPorInsumoId.get(insumoId);
            const nombreInsumo = pendiente.insumo.insumoCompleto?.descripcion || renglones[0]?.nombre || insumoId;
            const resultado = resData.resultados.find(r => r.insumoId?.toString() === insumoId.toString());
            const lotesFrescos = resultado?.lotesDisponibles || [];

            let suma = 0;
            renglones.forEach(({ salidaId, cantidad, numeroFila }) => {
                const loteFresco = lotesFrescos.find(l => l.salidaId.toString() === salidaId.toString());
                if (!loteFresco) {
                    errores.push(`Fila ${numeroFila} (${nombreInsumo}): ese lote ya no pertenece a esta venta`);
                    return;
                }
                if (cantidad > loteFresco.saldo + 0.0001) {
                    errores.push(`Fila ${numeroFila} (${nombreInsumo}): la cantidad (${cantidad}) excede el disponible del lote (${loteFresco.saldo})`);
                    return;
                }
                suma += cantidad;
            });

            if (Math.abs(suma - pendiente.insumo.cantidadNC) > 0.0001) {
                errores.push(`${nombreInsumo}: la suma de lotes (${suma}) no es igual a la cantidad a devolver (${pendiente.insumo.cantidadNC})`);
            }
        }

        if (errores.length > 0) {
            return this.mostrarErroresExcelLotes(errores);
        }

        const insumosForm = this.formRef.current.getFieldValue('insumos');
        for (const [insumoId, renglones] of repartoPorInsumoId.entries()) {
            const pendiente = pendientesPorInsumoId.get(insumoId);
            insumosForm[pendiente.arrayKey].lotesDevolucion = renglones.map(({ salidaId, cantidad }) => ({ salidaId, cantidad }));
        }
        this.formRef.current.setFieldsValue({ insumos: insumosForm });
        message.success(`Se repartieron los lotes de ${repartoPorInsumoId.size} insumo(s)`);
    }

    mostrarErroresExcelLotes(errores) {
        Modal.error({
            title: 'No se importaron los lotes',
            width: 700,
            content: (
                <ul style={{ paddingLeft: 20 }}>
                    {errores.map((error, i) => <li key={i}>{error}</li>)}
                </ul>
            ),
        });
    }

    abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
        if (proyectoId) {
            this.setState({
                modalElegirMarbetes: true,
                modalElegirMarbetesIndex: value,
                modalElegirMarbetesMarbetes: marbetes || [],
                modalElegirMarbetesInsumoId: insumoId,
                modalElegirMarbetesProyectoId: proyectoId
            })
        } else {
            message.warning('Elegir un proyecto para elegir marbetes')
        }
    }
    cerrarElegirMarbetes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirMarbetesIndex].marbetes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirMarbetes: false,
            modalElegirMarbetesIndex: null,
            modalElegirMarbetesMarbetes: null,
            modalElegirMarbetesInsumoId: null,
            modalElegirMarbetesProyectoId: null
        })
    }

    onChangePagarVenta(value) {
        if (value) {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d62', devolverDinero: false })
        } else {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d64' })
        }

        //6125149afe07662acc100d62 -- Condonacion
        //6125149afe07662acc100d64 -- Novacion
        //6125149afe07662acc100d58 -- Eectivo
    }

    onChangeCompensacion(value) {
        if (value) {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d58', pagarVenta: false })
        } else {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d64' })
        }
    }

    render() {
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Agregar Devolución"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background" style={{ paddingTop: 0 }}>
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="agregarDevolucion"
                            layout
                            bottom={
                                <ButtonItem
                                    type="primary"
                                    htmlType="submit"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Agregar
                                </ButtonItem>
                            }
                            onFinish={(values) => this.setState({ modalConfirmacion: true, valuesForm: values })}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Tabs defaultActiveKey={1} size="small">
                                <TabPane tab="General" tabKey={1} key={1} forceRender>
                                    <FormItem
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                            prev.insumos?.length !== curr.insumos?.length ||
                                            prev.factura !== curr.factura
                                        }
                                    >
                                        {({ getFieldValue }) => {
                                            const factura = getFieldValue("factura");
                                            return (
                                                <>
                                                    <Row>
                                                        <Col span={16}>
                                                            <HeaderItem>DATOS GENERALES</HeaderItem>
                                                            <BoxItem>
                                                                <Row>
                                                                    <Col span={8}>
                                                                        <FormItem
                                                                            required
                                                                            noStyle
                                                                            initialValue={2}
                                                                            name="factura"
                                                                            labelCol={{ span: 0 }}
                                                                            wrapperCol={{ span: 24 }}
                                                                        >
                                                                            <SelectItem
                                                                                width="80%"
                                                                                value={this.state.factura}
                                                                                onChange={(value) => {
                                                                                    this.formRef.current.setFieldsValue({
                                                                                        fechaDevolucion: moment(),
                                                                                    })
                                                                                    this.setState({ factura: value })
                                                                                }}
                                                                            >
                                                                                <Option value={2}>Remisión</Option>
                                                                                {this.props.permisoFacturarVentas && this.props.certificada && (
                                                                                    <Option value={1}>Factura</Option>
                                                                                )}
                                                                            </SelectItem>
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <FormItem
                                                                            label="Fecha"
                                                                            name="fechaDevolucion"
                                                                            required
                                                                            margin
                                                                            initialValue={moment()}
                                                                            labelCol={{ span: 6 }}
                                                                            wrapperCol={{ span: 20 }}
                                                                        >
                                                                            <DatePickerItem
                                                                                disabled={factura === 1}
                                                                                placeholder="Fecha de Devolucion"
                                                                                allowClear={false}
                                                                            />
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col span={8} />
                                                                </Row>
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <FormItem
                                                                            label="Cliente"
                                                                            name="clienteId"
                                                                            margin
                                                                            required
                                                                            labelCol={{ span: 2 }}
                                                                            wrapperCol={{ span: 22 }}
                                                                        >
                                                                            <SelectItem
                                                                                disabled
                                                                                placeholder="Cliente"
                                                                                onChange={(valueId) => this.onChangeCliente(valueId)}
                                                                            >
                                                                                {this.state.objetoClientes}
                                                                            </SelectItem>
                                                                        </FormItem>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <FormItem
                                                                            label="Vendedor"
                                                                            name="vendedorId"
                                                                            margin
                                                                            required
                                                                            labelCol={{ span: 2 }}
                                                                            wrapperCol={{ span: 22 }}
                                                                        >
                                                                            <SelectItem disabled placeholder="Vendedor">
                                                                                {this.state.objetoUsuarios}
                                                                            </SelectItem>
                                                                        </FormItem>
                                                                    </Col>
                                                                </Row>
                                                            </BoxItem>
                                                        </Col>

                                                        <Col span={8}>
                                                            <HeaderItem>MONEDA</HeaderItem>
                                                            <BoxItem>
                                                                <FormItem
                                                                    noStyle
                                                                    shouldUpdate={(prev, curr) =>
                                                                        prev.insumos?.length !==
                                                                        curr.insumos?.length
                                                                    }
                                                                >
                                                                    {({ getFieldValue }) => {
                                                                        const insumos = getFieldValue("insumos");

                                                                        //Por el momento

                                                                        const disabled =
                                                                            insumos && insumos.length > 0
                                                                                ? true
                                                                                : false;
                                                                        return (
                                                                            <FormItem
                                                                                required
                                                                                margin
                                                                                name="monedaId"
                                                                                label="Moneda"
                                                                                labelCol={{ span: 8 }}
                                                                                wrapperCol={{ span: 16 }}
                                                                                initialValue='60c7e4396465ad440c41c15a'
                                                                            >
                                                                                <SelectItem disabled={disabled} onChange={(value) => {
                                                                                    if (value === '60c7e4396465ad440c41c15a') {
                                                                                        this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                                                                    } else {
                                                                                        this.onChangeMoneda(value)
                                                                                    }
                                                                                }} placeholder="Moneda">
                                                                                    {this.state.objetoMonedas}
                                                                                </SelectItem>
                                                                            </FormItem>
                                                                        )
                                                                    }}
                                                                </FormItem>
                                                                <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.insumos?.length !== curr.insumos?.length}>
                                                                    {({ getFieldValue }) => {

                                                                        //Por el momento

                                                                        const monedaId = getFieldValue('monedaId')

                                                                        return (
                                                                            <FormItem
                                                                                required
                                                                                number
                                                                                margin
                                                                                label="T. Cambio"
                                                                                name="tipoDeCambio"
                                                                                type="number"
                                                                                initialValue={1}
                                                                                labelCol={{ span: 8 }}
                                                                                wrapperCol={{ span: 16 }}
                                                                            >
                                                                                <InputNumberItem
                                                                                    disabled={monedaId === '60c7e4396465ad440c41c15a'}
                                                                                    dinero
                                                                                    placeholder="T. Cambio"
                                                                                    onChange={(val) => {
                                                                                        if (monedaId === this.state.datosVenta?.monedaId) {
                                                                                            this.formRef.current.setFieldsValue({ tipoDeCambioVenta: val });
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </FormItem>
                                                                        )
                                                                    }}
                                                                </FormItem>
                                                                <FormItem shouldUpdate noStyle>
                                                                    {({ getFieldValue }) => {
                                                                        const pagarVenta = getFieldValue('pagarVenta')
                                                                        const devolverDinero = getFieldValue('devolverDinero')
                                                                        const monedaId = getFieldValue('monedaId')

                                                                        if (pagarVenta || devolverDinero) {
                                                                            return (
                                                                                <>
                                                                                    <p style={{ textAlign: 'center' }}>Moneda de la venta: {this.state.datosVenta?.moneda?.abreviacion}</p>
                                                                                    <FormItem
                                                                                        required
                                                                                        number
                                                                                        margin
                                                                                        label={`T. C. ${this.state.datosVenta?.moneda?.abreviacion ? this.state.datosVenta?.moneda?.abreviacion : ''}`}
                                                                                        name="tipoDeCambioVenta"
                                                                                        type="number"
                                                                                        initialValue={1}
                                                                                    >
                                                                                        <InputNumberItem
                                                                                            disabled={this.state.datosVenta?.monedaId === '60c7e4396465ad440c41c15a'}
                                                                                            dinero
                                                                                            placeholder={`T. C. ${this.state.datosVenta?.moneda?.abreviacion ? this.state.datosVenta?.moneda?.abreviacion : ''}`}
                                                                                            onChange={(val) => {
                                                                                                if (monedaId === this.state.datosVenta?.monedaId) {
                                                                                                    this.formRef.current.setFieldsValue({ tipoDeCambio: val });
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </FormItem>
                                                                                    <p style={{ textAlign: 'center' }}>Tipo de cambio venta: {dineroDisabledMask(this.state.datosVenta?.tipoDeCambio)}</p>
                                                                                </>
                                                                            )
                                                                        }
                                                                    }}
                                                                </FormItem>
                                                            </BoxItem>
                                                        </Col>

                                                    </Row>
                                                    <Row>
                                                        <Col span={6}>
                                                            <HeaderItem>PAGO</HeaderItem>
                                                            <BoxItem>
                                                                <FormItem shouldUpdate noStyle>
                                                                    {({ getFieldValue }) => {
                                                                        const devolverDinero = getFieldValue('devolverDinero')
                                                                        return (
                                                                            <>
                                                                                <FormItem
                                                                                    name="pagarVenta"
                                                                                    label="Pagar Venta"
                                                                                    tooltip={{ title: "Pagar la venta existente con esta devolución" }}
                                                                                    initialValue={true}
                                                                                    margin
                                                                                    pattern
                                                                                    valuePropName="checked"
                                                                                    labelCol={{ span: 12 }}
                                                                                    wrapperCol={{ span: 12 }}
                                                                                >
                                                                                    <SwitchItem onChange={this.onChangePagarVenta.bind(this)} />
                                                                                </FormItem>
                                                                                <FormItem
                                                                                    name="devolverDinero"
                                                                                    label="Compensación"
                                                                                    tooltip={{ title: "Regresar el dinero al cliente" }}
                                                                                    margin
                                                                                    pattern
                                                                                    valuePropName="checked"
                                                                                    labelCol={{ span: 12 }}
                                                                                    wrapperCol={{ span: 12 }}
                                                                                >
                                                                                    <SwitchItem onChange={this.onChangeCompensacion.bind(this)} />
                                                                                </FormItem>
                                                                                {devolverDinero &&
                                                                                    <FormItem
                                                                                        required
                                                                                        margin
                                                                                        name="bancoId"
                                                                                        label="Banco"
                                                                                        labelCol={{ span: 6 }}
                                                                                        wrapperCol={{ span: 18 }}
                                                                                    >
                                                                                        <SelectItem placeholder="Banco" >
                                                                                            {this.state.objetoBancos}
                                                                                        </SelectItem>
                                                                                    </FormItem>
                                                                                }
                                                                            </>
                                                                        )
                                                                    }}
                                                                </FormItem>
                                                            </BoxItem>
                                                        </Col>
                                                        <Col span={18}>
                                                            <HeaderItem>FORMA DE PAGO</HeaderItem>
                                                            <BoxItem>
                                                                <FormItem
                                                                    noStyle
                                                                    shouldUpdate={(prev, curr) =>
                                                                        prev.contado !== curr.contado ||
                                                                        prev.factura !== curr.factura
                                                                    }
                                                                >
                                                                    {({ getFieldValue }) => {
                                                                        const factura = getFieldValue("factura");
                                                                        const usoCFDI =
                                                                            factura === 1 ? (
                                                                                <FormItem
                                                                                    name="usoDeCfdiId"
                                                                                    label="Uso de CFDI"
                                                                                    initialValue="6123bd944518d23048736746"
                                                                                    margin
                                                                                    required
                                                                                    labelCol={{ span: 8 }}
                                                                                    wrapperCol={{ span: 16 }}
                                                                                >
                                                                                    <SelectItem placeholder="Uso de CFDI">
                                                                                        {this.state.objetoUsosDeCFDI}
                                                                                    </SelectItem>
                                                                                </FormItem>
                                                                            ) : null;
                                                                        return (
                                                                            <>
                                                                                <Row>
                                                                                    <FormItem
                                                                                        noStyle
                                                                                        shouldUpdate={(prev, curr) =>
                                                                                            prev.insumos?.length !==
                                                                                            curr.insumos?.length
                                                                                        }
                                                                                    >
                                                                                        {({ getFieldValue }) => {
                                                                                            const insumos =
                                                                                                getFieldValue("insumos");
                                                                                            const disabled =
                                                                                                insumos && insumos.length > 0
                                                                                                    ? true
                                                                                                    : false;
                                                                                            return (
                                                                                                <>
                                                                                                    <Col span={8}>
                                                                                                        <FormItem
                                                                                                            label="Proyecto"
                                                                                                            name="proyectoId"
                                                                                                            margin
                                                                                                            required
                                                                                                            labelCol={{ span: 8 }}
                                                                                                            wrapperCol={{ span: 16 }}
                                                                                                        >
                                                                                                            <SelectItem
                                                                                                                placeholder="Proyecto"
                                                                                                            >
                                                                                                                {this.state.objetoProyectos}
                                                                                                            </SelectItem>
                                                                                                        </FormItem>
                                                                                                    </Col>
                                                                                                    <Col span={8}>
                                                                                                        <FormItem
                                                                                                            name="precioId"
                                                                                                            label="Precio"
                                                                                                            margin
                                                                                                            required
                                                                                                            labelCol={{ span: 8 }}
                                                                                                            wrapperCol={{ span: 16 }}
                                                                                                        >
                                                                                                            <SelectItem
                                                                                                                placeholder="Precio"
                                                                                                                disabled={disabled}
                                                                                                            >
                                                                                                                {this.state.objetoPrecios}
                                                                                                            </SelectItem>
                                                                                                        </FormItem>
                                                                                                    </Col>
                                                                                                </>
                                                                                            );
                                                                                        }}
                                                                                    </FormItem>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col span={8}>
                                                                                        <FormItem
                                                                                            name="formaDePagoId"
                                                                                            label="F Pago"
                                                                                            initialValue="6125149afe07662acc100d62"
                                                                                            margin
                                                                                            required
                                                                                            labelCol={{ span: 8 }}
                                                                                            wrapperCol={{ span: 16 }}
                                                                                        >
                                                                                            <SelectItem placeholder="Forma de Pago">
                                                                                                {this.state.objetoFormasDePago}
                                                                                            </SelectItem>
                                                                                        </FormItem>
                                                                                    </Col>
                                                                                    <Col span={8}>
                                                                                        {usoCFDI}
                                                                                    </Col>
                                                                                </Row>
                                                                            </>
                                                                        );
                                                                    }}
                                                                </FormItem>
                                                            </BoxItem>
                                                        </Col>
                                                    </Row>
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                    <HeaderItem>INSUMOS</HeaderItem>
                                    {this.props.lotesCaducidades && (
                                        <FormItem noStyle shouldUpdate>
                                            {({ getFieldValue }) => {
                                                const insumosActuales = getFieldValue('insumos') || [];
                                                const hayPendientes = insumosActuales.some(insumo =>
                                                    insumo?.insumoCompleto?.inventariable &&
                                                    insumo?.insumoCompleto?.lotesCaducidades &&
                                                    insumo?.cantidadNC > 0
                                                );
                                                return (
                                                    <div style={{ marginBottom: 10 }}>
                                                        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }}>
                                                            <ButtonItem
                                                                onClick={this.descargarPlantillaLotes}
                                                                loading={this.state.loadingLotesExcel}
                                                            >
                                                                Descargar plantilla de lotes
                                                            </ButtonItem>
                                                            <Upload
                                                                showUploadList={false}
                                                                accept=".xlsx"
                                                                disabled={!hayPendientes}
                                                                beforeUpload={(file) => {
                                                                    this.cargarExcelLotes(file);
                                                                    return false;
                                                                }}
                                                            >
                                                                <ButtonItem
                                                                    verde
                                                                    disabled={!hayPendientes}
                                                                    icon={<UploadOutlined />}
                                                                    loading={this.state.loadingLotesExcel}
                                                                >
                                                                    Importar lotes desde Excel
                                                                </ButtonItem>
                                                            </Upload>
                                                            <ButtonItem
                                                                blanco
                                                                onClick={() => this.setState({ instruccionesLotesVisibles: !this.state.instruccionesLotesVisibles })}
                                                            >
                                                                {this.state.instruccionesLotesVisibles ? "Ocultar instrucciones" : "Ver instrucciones"}
                                                            </ButtonItem>
                                                        </div>
                                                        <Collapse activeKey={this.state.instruccionesLotesVisibles ? ["1"] : []} ghost>
                                                            <Collapse.Panel key="1" showArrow={false} header={null} collapsible="disabled">
                                                                <Alert
                                                                    type="info"
                                                                    showIcon
                                                                    message="Cómo importar los lotes desde Excel"
                                                                    description={
                                                                        <ul style={{ paddingLeft: 20, margin: 0 }}>
                                                                            <li>"Descargar plantilla de lotes" siempre está disponible. "Importar lotes desde Excel" se ve deshabilitado hasta que captures "Cantidad dev." en al menos un insumo con lote de esta venta.</li>
                                                                            <li>No modifiques ni borres las columnas <b>_insumoId</b> y <b>_salidaId</b>: son las que usa el sistema para saber a qué insumo y a qué lote corresponde cada fila. Si las cambias, esa fila no se podrá importar.</li>
                                                                            <li>Llena únicamente la columna <b>Cantidad a devolver</b>. Deja en blanco los lotes de los que no vas a devolver nada.</li>
                                                                            <li>La suma de "Cantidad a devolver" de todos los lotes de un mismo insumo debe ser igual a la "Cantidad dev." que capturaste para ese insumo en la tabla de abajo.</li>
                                                                            <li>Guarda el archivo sin cambiar los nombres de columna y súbelo con el botón "Importar lotes desde Excel".</li>
                                                                            <li>Si algo no cuadra (lote que ya no aplica, cantidad mayor al disponible, o la suma no coincide), no se aplica nada: se muestra el detalle del error para que corrijas el Excel y lo vuelvas a subir.</li>
                                                                        </ul>
                                                                    }
                                                                />
                                                            </Collapse.Panel>
                                                        </Collapse>
                                                    </div>
                                                );
                                            }}
                                        </FormItem>
                                    )}
                                    <BoxItem>
                                        <FormInitial.List name="insumos">
                                            {(fields) => (
                                                <>
                                                    <table className="table">
                                                        {fields.length > 0 ? (
                                                            <thead>
                                                                <tr>
                                                                    <th className="th-border" style={{ width: "18%" }}>
                                                                        Insumo
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "9%" }}>
                                                                        PU
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Cant.
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Entregado
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Desc.
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Subtotal
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Impuestos
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Total
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Cantidad dev.
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "8%" }}>
                                                                        Impuestos dev.
                                                                    </th>
                                                                    <th className="th-border" style={{ width: "9%" }}>
                                                                        Total dev.
                                                                    </th>
                                                                    {this.props.lotesCaducidades && (
                                                                        <th className="th-border-sin-right" style={{ width: "6%" }}></th>
                                                                    )}
                                                                </tr>
                                                            </thead>
                                                        ) : null}
                                                        {fields.map(
                                                            ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                                                <tbody key={arrayKey}>
                                                                    <tr>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "insumoId"]}
                                                                                required
                                                                                noStyle
                                                                            >
                                                                                <SelectItem
                                                                                    sinBorde
                                                                                    autoFocus
                                                                                    disabled
                                                                                    dropdownMatchSelectWidth={600}
                                                                                    width="100%"
                                                                                    placeholder="Insumo"
                                                                                >
                                                                                    {this.state.objetoInsumos}
                                                                                </SelectItem>
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "precioUnitario"]}
                                                                                noStyle
                                                                                required
                                                                                numberCero
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    placeholder="Precio Unitario"
                                                                                    dineroDisabled
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "cantidad"]}
                                                                                numberCero
                                                                                noStyle
                                                                                type="number"
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    placeholder={"Cantidad"}
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "entregado"]}
                                                                                numberCero
                                                                                noStyle
                                                                                type="number"
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    placeholder={"Entregado"}
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "descuento"]}
                                                                                required
                                                                                numberCero
                                                                                noStyle
                                                                                initialValue={0}
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    placeholder="Descuento"
                                                                                    porcentaje
                                                                                    disabled
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "subtotal"]}
                                                                                required
                                                                                numberCero
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    placeholder="Subtotal"
                                                                                    dineroDisabled
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "impuestos"]}
                                                                                required
                                                                                numberCero
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    dineroDisabled
                                                                                    placeholder="Impuestos"
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "total"]}
                                                                                required
                                                                                numberCero
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    dineroDisabled
                                                                                    disabled
                                                                                    placeholder="Total"
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                noStyle
                                                                                shouldUpdate={(prev, curr) =>
                                                                                    prev.insumos[arrayKey]?.entregado !==
                                                                                    curr.insumos[arrayKey]?.entregado
                                                                                }
                                                                            >
                                                                                {({ getFieldValue }) => {
                                                                                    const insumos = getFieldValue("insumos");
                                                                                    const entregado =
                                                                                        insumos[arrayKey].entregado || 0;
                                                                                    const cantidad =
                                                                                        insumos[arrayKey].cantidad || 0;
                                                                                    let max = Math.min(entregado, cantidad);

                                                                                    return (
                                                                                        <FormItem
                                                                                            {...restField}
                                                                                            name={[name, "cantidadNC"]}
                                                                                            numberCero
                                                                                            noStyle
                                                                                            type="number"
                                                                                            max={max}
                                                                                        >
                                                                                            <InputNumberItem
                                                                                                sinBorde
                                                                                                placeholder={
                                                                                                    (max || max === 0) && max !== Infinity
                                                                                                        ? "Max: " + max
                                                                                                        : "Cantidad dev"
                                                                                                }
                                                                                                onChange={(value) =>
                                                                                                    this.onChangePrecioCantidadDescuentoNC(
                                                                                                        false,
                                                                                                        arrayKey
                                                                                                    )
                                                                                                }
                                                                                            />
                                                                                        </FormItem>
                                                                                    );
                                                                                }}
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "impuestosNC"]}
                                                                                numberCero
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    dineroDisabled
                                                                                    placeholder="Impuestos"
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "totalNC"]}
                                                                                numberCero
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    dineroDisabled
                                                                                    disabled
                                                                                    placeholder="Total"
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        {this.props.lotesCaducidades && (
                                                                            <td className="td-border-sin-right">
                                                                                <FormItem noStyle shouldUpdate>
                                                                                    {({ getFieldValue }) => {
                                                                                        const arrayValue = getFieldValue("insumos");
                                                                                        const row = arrayValue?.[arrayKey];
                                                                                        const insumo = row?.insumoCompleto;
                                                                                        if (!insumo?.lotesCaducidades) return null;
                                                                                        return (
                                                                                            <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "90%", marginLeft: "5%" }}>
                                                                                                <Tooltip title="Elegir de qué lote(s) de la venta viene esta devolución">
                                                                                                    <ButtonItem
                                                                                                        type="primary"
                                                                                                        size="small"
                                                                                                        block
                                                                                                        verde={row?.lotesDevolucion?.length > 0}
                                                                                                        onClick={() =>
                                                                                                            this.abrirElegirLotesDevolucion(
                                                                                                                arrayKey,
                                                                                                                row?.lotesDevolucion,
                                                                                                                row?.insumoId,
                                                                                                                row?.cantidadNC
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        Lote origen
                                                                                                    </ButtonItem>
                                                                                                </Tooltip>
                                                                                                <ButtonItem
                                                                                                    type="primary"
                                                                                                    size="small"
                                                                                                    block
                                                                                                    verde={row?.lotes?.length > 0}
                                                                                                    onClick={() =>
                                                                                                        this.abrirAgregarLotes(
                                                                                                            arrayKey,
                                                                                                            row?.lotes,
                                                                                                            insumo?.insumoPrincipalId
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    Lotes
                                                                                                </ButtonItem>
                                                                                            </div>
                                                                                        );
                                                                                    }}
                                                                                </FormItem>
                                                                            </td>
                                                                        )}
                                                                    </tr>
                                                                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
                                                                        {({ getFieldValue }) => {
                                                                            let arrayValue = getFieldValue("insumos");
                                                                            if (arrayValue[arrayKey]?.leyenda) {
                                                                                return (
                                                                                    <tr>
                                                                                        <td colSpan="11" className="td-border">
                                                                                            <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                                                                                                <div style={{ width: '90%', textAlign: 'left', paddingLeft: 20 }}>
                                                                                                    <b>Leyenda:</b> {arrayValue[arrayKey].leyenda}
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        }}
                                                                    </FormItem>
                                                                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml}>
                                                                        {({ getFieldValue }) => {
                                                                            let arrayValue = getFieldValue("insumos");
                                                                            if (arrayValue[arrayKey]?.observaciones) {
                                                                                return (
                                                                                    <tr>
                                                                                        <td colSpan="11" className="td-border-sin-right">
                                                                                            <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', backgroundColor: arrayValue[arrayKey].observacionesXml ? '#dceeffff' : 'white' }}>
                                                                                                <div style={{ width: '90%', textAlign: 'left', paddingLeft: 20 }}>
                                                                                                    {/* <b>Observaciones:</b><br /> */}
                                                                                                    {String(arrayValue[arrayKey].observaciones)
                                                                                                        .split(/\r?\n/)
                                                                                                        .map((line, i) => <span key={i}>{line}<br /></span>)}
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        }}
                                                                    </FormItem>
                                                                </tbody>
                                                            )
                                                        )}
                                                    </table>
                                                </>
                                            )}
                                        </FormInitial.List>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={8}>
                                                <FormItem
                                                    pattern
                                                    name='observaciones'
                                                    label='Observaciones'
                                                >
                                                    <TextAreaItem />
                                                </FormItem>
                                            </Col>
                                            <Col span={4}>
                                                <FormItem
                                                    label="Imprimir"
                                                    name="imprimirObservaciones"
                                                    valuePropName="checked"
                                                >
                                                    <Checkbox></Checkbox>
                                                </FormItem>
                                            </Col>
                                            <Col span={6}>
                                                <table className="table" style={{ marginTop: 0 }}>
                                                    <tbody>
                                                        <tr>
                                                            <th className="th-totales" style={{ width: "50%" }}>
                                                                Subtotal
                                                            </th>
                                                            <td
                                                                className="td-totales-right"
                                                                style={{ width: "50%" }}
                                                            >
                                                                {dineroDisabledMask(this.state.subtotalVenta)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    {this.state.arrayImpuestosVenta && this.state.arrayImpuestosVenta.map((valueArray) => (
                                                        <tbody>
                                                            <tr key={valueArray.descripcionFactura}>
                                                                <th className="th-totales">
                                                                    {valueArray.descripcionFactura}
                                                                </th>
                                                                <td className="td-totales-right">
                                                                    {dineroDisabledMask(valueArray.totalImpuestos)}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ))}
                                                    <tbody>
                                                        <tr>
                                                            <th className="th-totales">Total</th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(this.state.totalVenta)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    {this.state.arrayRetencionesVenta && this.state.arrayRetencionesVenta.map(
                                                        (valueArrayRetenciones) => (
                                                            <tbody>
                                                                <tr key={valueArrayRetenciones.descripcionFactura}>
                                                                    <th className="th-totales">
                                                                        {valueArrayRetenciones.descripcionFactura}
                                                                    </th>
                                                                    <td className="td-totales-right">
                                                                        {dineroDisabledMask(
                                                                            valueArrayRetenciones.totalRetenciones
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        )
                                                    )}
                                                    <tbody>
                                                        <tr>
                                                            <th className="th-totales">Total Pagar</th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(this.state.totalPagarVenta)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Col>
                                            <Col span={6}>
                                                <FormItem shouldUpdate noStyle>
                                                    {({ getFieldValue }) => {
                                                        let arrayInsumos = getFieldValue("insumos") || [];
                                                        let arrayRetenciones = [];
                                                        let cuentasCliente = 0;
                                                        let subtotal = 0;
                                                        let arrayImpuestos = [];
                                                        let total = 0;
                                                        arrayInsumos.map((value) => {
                                                            if (value) {
                                                                if (
                                                                    value.subtotalNC &&
                                                                    value.totalNC &&
                                                                    value.arrayImpuestosNC
                                                                ) {
                                                                    subtotal += value.subtotalNC;
                                                                    total += value.subtotalNC;
                                                                    value.arrayImpuestosNC.map((valueImpuestos) => {
                                                                        let index = arrayImpuestos.findIndex(
                                                                            (valueImpuestosAnterios) =>
                                                                                valueImpuestosAnterios.descripcionFactura ===
                                                                                valueImpuestos.descripcionFactura
                                                                                &&
                                                                                valueImpuestosAnterios.tasaCuota ===
                                                                                valueImpuestos.tasaCuota
                                                                                &&
                                                                                valueImpuestosAnterios.impuesto ===
                                                                                valueImpuestos.impuesto
                                                                        );
                                                                        if (index !== -1) {
                                                                            let newItem = {
                                                                                totalImpuestos:
                                                                                    arrayImpuestos[index].totalImpuestos +
                                                                                    valueImpuestos.totalImpuestos,
                                                                                baseImpuesto:
                                                                                    arrayImpuestos[index].baseImpuesto +
                                                                                    valueImpuestos.baseImpuesto,
                                                                                descripcionFactura:
                                                                                    valueImpuestos.descripcionFactura,
                                                                                tasaCuota:
                                                                                    valueImpuestos.tasaCuota,
                                                                                impuesto:
                                                                                    valueImpuestos.impuesto,
                                                                                montoImpuesto:
                                                                                    valueImpuestos.montoImpuesto,
                                                                                local: valueImpuestos.local,
                                                                            };
                                                                            arrayImpuestos.splice(index, 1, newItem);
                                                                        } else {
                                                                            arrayImpuestos.push({
                                                                                tasaCuota: valueImpuestos.tasaCuota,
                                                                                impuesto: valueImpuestos.impuesto,
                                                                                local: valueImpuestos.local,
                                                                                montoImpuesto: valueImpuestos.montoImpuesto,
                                                                                baseImpuesto: valueImpuestos.baseImpuesto,
                                                                                descripcionFactura: valueImpuestos.descripcionFactura,
                                                                                totalImpuestos: valueImpuestos.totalImpuestos,
                                                                            });
                                                                        }
                                                                        return null;
                                                                    });
                                                                    if (value.arrayRetencionesNC) {
                                                                        value.arrayRetencionesNC.map((valueRetenciones) => {
                                                                            let index = arrayRetenciones.findIndex(
                                                                                (valueRetencionesAnterios) =>
                                                                                    valueRetencionesAnterios.descripcionFactura ===
                                                                                    valueRetenciones.descripcionFactura
                                                                                    &&
                                                                                    valueRetencionesAnterios.tasaCuota ===
                                                                                    valueRetenciones.tasaCuota
                                                                                    &&
                                                                                    valueRetencionesAnterios.impuesto ===
                                                                                    valueRetenciones.impuesto
                                                                            );
                                                                            cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                                                                            if (index !== -1) {
                                                                                let newItem = {
                                                                                    totalRetenciones:
                                                                                        arrayRetenciones[index].totalRetenciones +
                                                                                        valueRetenciones.totalRetenciones,
                                                                                    baseRetencion:
                                                                                        arrayRetenciones[index].baseRetencion +
                                                                                        valueRetenciones.baseRetencion,
                                                                                    descripcionFactura:
                                                                                        valueRetenciones.descripcionFactura,
                                                                                    tasaCuota:
                                                                                        valueRetenciones.tasaCuota,
                                                                                    impuesto:
                                                                                        valueRetenciones.impuesto,
                                                                                    montoRetencion:
                                                                                        valueRetenciones.montoRetencion,
                                                                                    local: valueRetenciones.local,
                                                                                };
                                                                                arrayRetenciones.splice(index, 1, newItem);
                                                                            } else {
                                                                                arrayRetenciones.push({
                                                                                    tasaCuota: valueRetenciones.tasaCuota,
                                                                                    impuesto: valueRetenciones.impuesto,
                                                                                    montoRetencion: valueRetenciones.montoRetencion,
                                                                                    local: valueRetenciones.local,
                                                                                    baseRetencion: valueRetenciones.baseRetencion,
                                                                                    descripcionFactura: valueRetenciones.descripcionFactura,
                                                                                    totalRetenciones: valueRetenciones.totalRetenciones,
                                                                                });
                                                                            }
                                                                            return null;
                                                                        });
                                                                    }
                                                                }
                                                            }
                                                            return null;
                                                        });
                                                        arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
                                                            total += round2Decimals(valueImpuesto.totalImpuestos)
                                                            return {
                                                                ...valueImpuesto,
                                                                totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
                                                            }
                                                        })
                                                        if (this.state.totalPagar !== (total - cuentasCliente)) {
                                                            this.setState({ totalPagar: (total - cuentasCliente) });
                                                        }
                                                        return (
                                                            <table className="table" style={{ marginTop: 0 }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <th
                                                                            className="th-totales"
                                                                            style={{ width: "50%" }}
                                                                        >
                                                                            Subtotal dev.
                                                                        </th>
                                                                        <td
                                                                            className="td-totales-right"
                                                                            style={{ width: "50%" }}
                                                                        >
                                                                            {dineroDisabledMask(subtotal)}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                {arrayImpuestos.map((valueArray) => (
                                                                    <tbody>
                                                                        <tr key={valueArray.descripcionFactura}>
                                                                            <th className="th-totales">
                                                                                {valueArray.descripcionFactura + ' dev.'}
                                                                            </th>
                                                                            <td className="td-totales-right">
                                                                                {dineroDisabledMask(
                                                                                    valueArray.totalImpuestos
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                ))}
                                                                <tbody>
                                                                    <tr>
                                                                        <th className="th-totales">Total dev.</th>
                                                                        <td className="td-totales-right">
                                                                            {dineroDisabledMask(total)}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                {arrayRetenciones.map((value) => (
                                                                    <tbody>
                                                                        <tr>
                                                                            <th className="th-totales">
                                                                                {value.descripcionFactura + ' dev.'}
                                                                            </th>
                                                                            <td className="td-totales-right">
                                                                                {dineroDisabledMask(value.totalRetenciones)}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                ))}
                                                                <tbody>
                                                                    <tr>
                                                                        <th className="th-totales">Total a Pagar dev.</th>
                                                                        <td className="td-totales-right">
                                                                            {dineroDisabledMask(total - cuentasCliente)}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        );
                                                    }}
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </BoxItem>
                                </TabPane>
                                <TabPane tab='CFDIs Relacionados' tabKey='4' key='4' forceRender>
                                    <TabRelaciones />
                                </TabPane>
                            </Tabs>
                        </Form>
                    </Spin>
                </div>
                <MandarCorreoDevolucion
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreoDevolucion={this.cerrarMandarCorreoDevolucion.bind(this)}
                />
                <AgregarLotes
                    visible={this.state.modalAgregarLotes}
                    cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
                    lotes={this.state.modalAgregarLotesLotes}
                    insumoId={this.state.modalAgregarLotesInsumoId}
                />
                <ElegirLotesDevolucion
                    visible={this.state.modalElegirLotesDevolucion}
                    cerrarElegirLotesDevolucion={this.cerrarElegirLotesDevolucion.bind(this)}
                    lotes={this.state.modalElegirLotesDevolucionLotes}
                    insumoId={this.state.modalElegirLotesDevolucionInsumoId}
                    ventaId={this.state.ventaId}
                    cantidad={this.state.modalElegirLotesDevolucionCantidad}
                    modoCantidad="exacta"
                />
                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    onOk={() => {
                        this.setState({ modalConfirmacion: false });
                        this.onFinish(this.state.valuesForm);
                    }}
                    spinning={false}
                    footer
                >
                    <h1 style={{ textAlign: 'center' }}>Desea continuar</h1>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
        certificada: state.empresa.certificada,
        lotesCaducidades: state.empresa.lotesCaducidades,
    };
};

export default connect(mapStateToProps)(AgregarDevolucion);
